export enum LiveStockTypes {
    GROWTH_STAGES = 'growthStages',
    FEED_TRANSPORTATION = 'growthStagesFeedData',
    MANURE_MANAGEMENT = 'manureManagement'
}
export const GrowthStageFeedindSituationMeta = [
    {
        label: 'Stall',
        value: 'stall',
    },
    {
        label: 'Pasture',
        value: 'pasture',
    },
    {
        label: 'Grazing large areas',
        value: 'grazing_large_areas',
    }]

export const GrowthStageUnitMeta = [
    {
        label: 'kg',
        value: 'kg',
    },
    {
        label: 'lb',
        value: 'pounds',
    },
    {
        label: 'g',
        value: 'g',
    },
    {
        label: 'tonnes',
        value: 'tonnes',
    }
]